import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import appConfig from '../../consumingApi/services/appConfig';
import LogisticService from '@LogisticService';
import { manuallyAlocatePin } from './pinsSlice';
import { createDeliveryMockRsponse, simulationListMockResponse } from './tempMocks';
import { uuidToShortString } from '../../utils/common';

const BASE_URL = appConfig.logisticsUrl;
const REDUCER_NAME = 'senninhaManageRoutes';
const GET_BALANCE = 'senninhaManageRoutes/getBalance'
const POST_MANAGEALLROUTES = 'senninhaManageRoutes/postManageAllRoutes';
const POST_SIMULATE_DELIVERIES = 'senninhaManageRoutes/postSimulateDeliveries';
const POST_REQUEST_DELIVERIES = 'senninhaManageRoutes/postRequestDeliveries';
const POST_REQUEST_DELIVERIES_AUTONOMOS = 'senninhaManageRoutes/postRequestDeliveriesAutonomos';


const initialState = {
  balanceData: {
    balance: 0,
    dailyLimit: '',
  },
  simulationsData: null,
  simulationClient: null,
  requestedDeliveriesHashes: null,
  requestDeliveriesOssErrors: null,
  routeManagementOption: 'realocar',
  areaSelectionMode: null,
  selectedRelocatePins: [],
  selectedPreDeliveryPins: [],
  preDeliveryPinsInWork: [],
  manageAllRoutesProgress: {
    successes: [],
    errors: [],
    errorsMessages: [],
    retryPayload: [],
  },
  flagOpenTrackDeliveries: false,
  flagOpenTrackDeliveriesAutonomos: false,
  statusGetBalance: 'idle',
  statusManageAllRoutes: 'idle',
  statusSimulatePreDeliveries: 'idle',
  statusRequestPreDeliveries: 'idle',
  errorGetBalance: null,
  unassociatedPinAnyData: {
    unassociatedPin: null,
    deliveriesPins2BeAssociated: null,
  },
  statusManageAllRoutes: "idle",
  errorManageAllRoutes: null,
  errorSimulatePreDeliveries: null,
  errorRequestPreDeliveries: null,
};

export const postManageAllRoutes = createAsyncThunk(
  POST_MANAGEALLROUTES,
  async ({ data, batchSize = 3 }, { rejectWithValue, dispatch }) => {
    let successes = [];
    let errors = [];
    let errorsMessages = [];
    let retryPayload = [];

    const allJobs = [];
    for (const routeData of data) {
      for (const pin of routeData.pins) {

        const isAssociatedEntrega =
          pin.servico.toLowerCase() === "entrega" &&
          routeData.pins.some(
            (otherPin) =>
              otherPin.servico.toLowerCase() === "coleta" &&
              otherPin.associatedPinsIDs?.includes(pin.id)
          );

        if (isAssociatedEntrega) {
          continue;
        }

        for (const os of pin.oss) {
          allJobs.push({
            pin: pin,
            os: os,
            routeData: routeData,
          });
        }
      }
    }

    const numBatches = Math.ceil(allJobs.length / batchSize);

    for (let batchIndex = 0; batchIndex < numBatches; batchIndex++) {
      const batchOfJobs = allJobs.slice(
        batchIndex * batchSize,
        (batchIndex + 1) * batchSize
      );

      if (batchIndex > 0) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }

      await Promise.all(
        batchOfJobs.map(async (job) => {
          const { pin, os, routeData } = job;

          const payload = {
            id_atendimento: os.id_atendimento,
            contratante: pin.contratante,
            angel: routeData.type === "deallocation" ? "" : routeData.angel.email,
            documento: routeData.type === "deallocation" ? "" : routeData.angel.document_number,
            nome_tecnico: routeData.type === "deallocation" ? "" : routeData.angel.nome,
            polo: routeData.polo,
            campanha: routeData.campanha,
            oss: [os],
          };

          const today = new Date();
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          const customerDeadlineDate = new Date(os.customer_deadline_date);

          try {
            await LogisticService.postWithAuth(
              `${BASE_URL}/atendimento/senninha/rotas/${routeData.polo}`,
              payload
            );

            successes.push(pin);
            dispatch(addProgressState({ type: "success", data: pin }));
            dispatch(
              manuallyAlocatePin({
                id: pin.id,
                angel:
                  routeData.type === "deallocation"
                    ? customerDeadlineDate < yesterday
                      ? "Vencidas (Não alocadas)"
                      : customerDeadlineDate > today
                        ? "Vencimento futuros (Não alocadas)"
                        : "Vencem hoje (Não alocadas)"
                    : routeData.angel.nome,
              })
            );
          } catch (err) {
            const error = err?.response?.data?.erro || "error";
            errorsMessages.push(`${os.id_atendimento} - ${error}`);
            errors.push(pin);
            retryPayload.push({ ...routeData, pins: [{ ...pin, oss: [os] }] });
            dispatch(addProgressState({ type: "error", data: pin }));
          }
        })
      );
    }

    if (errors.length) {
      return rejectWithValue({ errors, errorsMessages, retryPayload });
    }

    return { successes, errors, errorsMessages, retryPayload };
  }
);

export const getBalance = createAsyncThunk(GET_BALANCE, async (asd, { rejectWithValue }) => {
  try {
    // const res = await LogisticService.requestWithAuth(`${BASE_URL}/atendimento/senninha/-/${asd}`);
    const res = await new Promise((resolve) => setTimeout(() => resolve({
      data: {
        saldo: 57.69,
        limite_diario: 'Limite de R$54,90/dia'
      }
    }), 1000))
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.erro || 'error');
  }
});

export const postSimulatePreDeliveries = createAsyncThunk(POST_SIMULATE_DELIVERIES, async (payload, { rejectWithValue, dispatch }) => {
  try {
    const res = await LogisticService.postWithAuth(
      `${BASE_URL}/any/simular_delivery`,
      payload
    );
    dispatch(resetRequestPreDeliveriesStatus())
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.response?.data?.error || 'error');
  }
});

export const postRequestPreDeliveries = createAsyncThunk(POST_REQUEST_DELIVERIES, async (data, { rejectWithValue, dispatch }) => {
  try {

    const res = await LogisticService.postWithAuth(`${BASE_URL}/any/criar_delivery/${data.tryToCreateDelivery || false}`, data.payload);

    if (data.pins2BeUpdated.length) {
      data.pins2BeUpdated.forEach((item) => {
        dispatch(
          manuallyAlocatePin(item)
        );
      })
    }
    const resFormatted = await Promise.all(res.data.map(async (item) => await uuidToShortString(item.referenceKey)))
    const ossErrors = res.data.reduce((res, item) => 
      item?.erros_parciais_oss?.length ? 
        [...res, ...item.erros_parciais_oss.map((err) => err)] 
        : res
    , [])

    return {
      badgesNumbers: resFormatted,
      ossErrors: ossErrors.length ? ossErrors : null
    };
  } catch (err) {
    return rejectWithValue(err?.response?.data?.error || err?.response?.data?.title || err?.response?.data?.message || err?.response?.data || 'error');
  }
});

export const postRequestPreDeliveriesAutonomos = createAsyncThunk(POST_REQUEST_DELIVERIES_AUTONOMOS, async (data, { rejectWithValue, dispatch }) => {
  try {
    const res = await LogisticService.postWithAuth(`${BASE_URL}/any/criar_delivery_autonomos`, data.payload);

    const resFormatted = await Promise.all(res.data.map(async (item) => await uuidToShortString(item.reference_key)))
    const ossErrors = res.data.reduce((res, item) =>
      item?.erros_parciais_oss?.length ?
        [...res, ...item.erros_parciais_oss.map((err) => err)]
        : res
    , [])

    return {
      badgesNumbers: resFormatted,
      ossErrors: ossErrors.length ? ossErrors : null
    };
  } catch (err) {
    return rejectWithValue(err?.response?.data?.error || err?.response?.data?.title || err?.response?.data?.message || err?.response?.data || 'error');
  }
});

export const routesManagementSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    manageSelectedRelocatePins: (state, action) => {
      const { id, id_atendimento, tipo, oss, servico, associatedPinsIDs } = action.payload;

      const pinAlreadySelected = state.selectedRelocatePins.find((item) => item.id === id)
      
      if (pinAlreadySelected) {
        const sameOSsLength = oss.length === pinAlreadySelected.oss.length
        const pinAdq = tipo !== 'any' && id_atendimento === pinAlreadySelected.id_atendimento
        const isCollectPin = servico.toLowerCase() === 'coleta'

        if (sameOSsLength || pinAdq || isCollectPin) {
          state.selectedRelocatePins = state.selectedRelocatePins.filter((item) => item.id !== id)

          if (servico.toLowerCase() === 'coleta' && associatedPinsIDs?.length) {
            state.selectedRelocatePins = state.selectedRelocatePins.filter((item) => !associatedPinsIDs.includes(item.id))
          }
      } else {
          state.selectedRelocatePins = state.selectedRelocatePins.map(
            (item) => item.id === id ? 
              action.payload 
              : item
            )
          state.selectedRelocatePins = state.selectedRelocatePins.filter((item) => item.oss.length !== 0)
        }
      } else {
        state.selectedRelocatePins = [
          ...state.selectedRelocatePins, 
          action.payload
        ]
      }
    },
    manageSelectedPredeliveryPins: (state, action) => {
      const { id, id_atendimento, tipo, oss, servico, associatedPinsIDs } = action.payload;

      const pinAlreadySelected = state.selectedPreDeliveryPins.find((item) => item.id === id)
      
      if (pinAlreadySelected) {
        const sameOSsLength = oss.length === pinAlreadySelected.oss.length
        const pinAdq = tipo !== 'any' && id_atendimento === pinAlreadySelected.id_atendimento
        const isCollectPin = servico.toLowerCase() === 'coleta'

        if (sameOSsLength || pinAdq || isCollectPin) {
          state.selectedPreDeliveryPins = state.selectedPreDeliveryPins.filter((item) => item.id !== id)

          if (servico.toLowerCase() === 'coleta' && associatedPinsIDs?.length) {
            state.selectedPreDeliveryPins = state.selectedPreDeliveryPins.filter((item) => !associatedPinsIDs.includes(item.id))
          }
      } else {
          state.selectedPreDeliveryPins = state.selectedPreDeliveryPins.map(
            (item) => item.id === id ? 
              action.payload 
              : item
            )
          state.selectedPreDeliveryPins = state.selectedPreDeliveryPins.filter((item) => item.oss.length !== 0)
        }
      } else {
        state.selectedPreDeliveryPins = [
          ...state.selectedPreDeliveryPins, 
          servico.toLowerCase() === 'coleta' ? { ...action.payload, oss: [] } : action.payload
        ]
      }
    },
    setRouteManagementOption: (state, action) => {
      state.routeManagementOption = action.payload;
    },
    setAreaSelectionMode: (state, action) => {
      state.areaSelectionMode = action.payload;
    },
    resetSelectedRelocatePins: (state) => {
        state.selectedRelocatePins = []
    },
    addPreDeliveryPinsInWork: (state, action) => {
      const { pins, shouldReset } = action.payload;
      state.preDeliveryPinsInWork = [...(shouldReset ? [] : state.preDeliveryPinsInWork), ...pins]
    },
    removePreDeliveryPinsInWork: (state, action) => {
        state.preDeliveryPinsInWork = state.preDeliveryPinsInWork.filter((item) => item.id_atendimento !== action.payload)
    },
    resetPreDeliveryPinsInWork: (state) => {
      state.preDeliveryPinsInWork = []
  },
    resetSelectedPreDeliveryPins: (state) => {
        state.selectedPreDeliveryPins = []
    },
    addProgressState: (state, action) => {
      const { type, data } = action.payload;
      if (type === "success") {
        state.manageAllRoutesProgress = {
          ...state.manageAllRoutesProgress,
          successes: [...state.manageAllRoutesProgress.successes, data],
        };
      } else if (type === "error") {
        state.manageAllRoutesProgress = {
          ...state.manageAllRoutesProgress,
          errors: [...state.manageAllRoutesProgress.errors, data],
        };
      } else {
        state.manageAllRoutesProgress = {
          ...state.manageAllRoutesProgress,
          retryPayload: [...state.manageAllRoutesProgress.retryPayload, data],
        };
      }
    },
    resetSimulatioinsData: (state) => {
      state.simulationsData = null;
      state.statusSimulatePreDeliveries = 'idle';
      state.errorSimulatePreDeliveries = null;
    },
    deleteSimulationData: (state, action) => {
      const aux = {
        ...state.simulationsData,
        simulacoes: state.simulationsData.simulacoes.filter((item) => 
          item.id_simulacao !== action.payload
        )
      }
      if (!aux.simulacoes.length) {
        state.statusSimulatePreDeliveries = 'idle'
        state.simulationsData = null
        state.selectedPreDeliveryPins = []
      } else state.simulationsData = aux
    },
    resetRoutesManagementStates: (state) => {
      (state.manageAllRoutesProgress = {
        successes: [],
        errors: [],
        errorsMessages: [],
        retryPayload: [],
      }),
        (state.statusManageAllRoutes = "idle");
      state.errorManageAllRoutes = null;
    },
    resetRoutesManagementStatus: (state) => {
      state.statusManageAllRoutes = "idle";
    },
    resetRoutesManagementSlice: () => {
      state = initialState;
    },
    setUnassociatedPinAnyData: (state, action) => {
      state.unassociatedPinAnyData = action.payload;
    },
    resetUnassociatedPinAnyData: (state) => {
      state.unassociatedPinAnyData = {
        unassociatedPin: null,
        deliveriesPins2BeAssociated: null,
      };
    },

    resetSimulatePreDeliveriesStatus: (state) => {
      state.statusSimulatePreDeliveries = 'idle'
    },
    setSimulationDataLocal: (state, action) => {
      state.simulationsData = action.payload
      state.statusSimulatePreDeliveries = 'fulfilled'
      state.errorSimulatePreDeliveries = null
    },
    resetRequestPreDeliveriesStatus: (state) => {
      state.statusRequestPreDeliveries = 'idle'
    },
    setFlagOpenTrackDeliveries: (state, action) => {
      state.flagOpenTrackDeliveries = action.payload
    },
    setFlagOpenTrackDeliveriesAutonomos: (state, action) => {
      state.flagOpenTrackDeliveriesAutonomos = action.payload
    },
    resetRoutesManagementSlice: (state) => {
      state = initialState
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBalance.pending, (state) => {
        state.statusGetBalance = 'pending';
        state.errorGetBalance = null;
      })
      .addCase(getBalance.fulfilled, (state, action) => {
        const { saldo: balance, limite_diario: dailyLimit } = action.payload
        state.balanceData = {
          balance,
          dailyLimit
        }
        state.statusGetBalance = 'fulfilled';
      })
      .addCase(getBalance.rejected, (state, action) => {
        state.errorGetBalance = action.payload;
        state.statusGetBalance = 'rejected';
      })
      .addCase(postManageAllRoutes.pending, (state) => {
        state.statusManageAllRoutes = 'pending';
        state.errorManageAllRoutes = null;
      })
      .addCase(postManageAllRoutes.fulfilled, (state, action) => {
        state.manageAllRoutesProgress = action.payload;
        state.statusManageAllRoutes = "fulfilled";
      })
      .addCase(postManageAllRoutes.rejected, (state, action) => {
        const { errors, errorsMessages, retryPayload } = action.payload;
        state.manageAllRoutesProgress = {
          ...state.manageAllRoutesProgress,
          errors,
          errorsMessages,
          retryPayload,
        };
        state.errorManageAllRoutes = action.payload;
        state.statusManageAllRoutes = 'rejected';
      })
      .addCase(postSimulatePreDeliveries.pending, (state) => {
        state.simulationsData = null;
        state.statusSimulatePreDeliveries = 'pending';
        state.errorSimulatePreDeliveries = null;
      })
      .addCase(postSimulatePreDeliveries.fulfilled, (state, action) => {
        state.simulationsData = action.payload;
        state.statusSimulatePreDeliveries = 'fulfilled';
      })
      .addCase(postSimulatePreDeliveries.rejected, (state, action) => {
        state.errorSimulatePreDeliveries = action.payload;
        state.statusSimulatePreDeliveries = 'rejected';
      })
      .addCase(postRequestPreDeliveries.pending, (state) => {
        state.errorRequestPreDeliveries = null;
        state.requestDeliveriesOssErrors = null;
        state.statusRequestPreDeliveries = 'pending';
        state.requestedDeliveriesHashes = null;
      })
      .addCase(postRequestPreDeliveries.fulfilled, (state, action) => {
        state.requestedDeliveriesHashes = action.payload.badgesNumbers;
        state.requestDeliveriesOssErrors = action.payload.ossErrors
        state.statusRequestPreDeliveries = 'fulfilled';
      })
      .addCase(postRequestPreDeliveries.rejected, (state, action) => {
        state.errorRequestPreDeliveries = action.payload;
        state.statusRequestPreDeliveries = 'rejected';
        state.requestedDeliveriesHashes = null;
        state.requestDeliveriesOssErrors = null;
      })
      .addCase(postRequestPreDeliveriesAutonomos.pending, (state) => {
        state.errorRequestPreDeliveries = null;
        state.requestDeliveriesOssErrors = null;
        state.statusRequestPreDeliveries = 'pending';
        state.requestedDeliveriesHashes = null;
      })
      .addCase(postRequestPreDeliveriesAutonomos.fulfilled, (state, action) => {
        state.requestedDeliveriesHashes = action.payload.badgesNumbers;
        state.requestDeliveriesOssErrors = action.payload.ossErrors
        state.statusRequestPreDeliveries = 'fulfilled';
      })
      .addCase(postRequestPreDeliveriesAutonomos.rejected, (state, action) => {
        state.errorRequestPreDeliveries = action.payload;
        state.statusRequestPreDeliveries = 'rejected';
        state.requestedDeliveriesHashes = null;
        state.requestDeliveriesOssErrors = null;
      });
  },
});

export const {
  manageSelectedRelocatePins,
  manageSelectedPredeliveryPins,
  setRouteManagementOption,
  setAreaSelectionMode,
  resetSelectedRelocatePins,
  resetSimulatioinsData,
  addPreDeliveryPinsInWork,
  removePreDeliveryPinsInWork,
  resetPreDeliveryPinsInWork,
  resetSelectedPreDeliveryPins,
  addProgressState,
  deleteSimulationData,
  resetRoutesManagementSlice,
  resetRoutesManagementStates,
  resetRoutesManagementStatus,
  resetRequestPreDeliveriesStatus,
  setFlagOpenTrackDeliveries,
  setFlagOpenTrackDeliveriesAutonomos,
  resetSimulatePreDeliveriesStatus,
  setSimulationDataLocal,
  setUnassociatedPinAnyData,
  resetUnassociatedPinAnyData,
} = routesManagementSlice.actions;

export const routesManagementSelector = (state) => state.routesManagementSlice;

export const selectAllSelectedPinIds = createSelector(
  [
    (state) => state.routesManagementSlice.selectedRelocatePins,
    (state) => state.routesManagementSlice.selectedPreDeliveryPins,
    (state) => state.routesManagementSlice.routeManagementOption,
  ],
  (selectedRelocatePins, selectedPreDeliveryPins, routeManagementOption) => {
    const isPreDelivery = routeManagementOption === 'preDelivery';
    const ids = new Set();
    const atendIds = new Set();
    selectedRelocatePins.concat(selectedPreDeliveryPins).forEach((item) => {
      if (isPreDelivery && item?.tipo?.toLowerCase() === 'any') return;
      if (item?.id !== undefined && item?.id !== null) ids.add(item.id);
      if (
        item?.id_atendimento !== undefined
        && item?.id_atendimento !== null
        && typeof item.id_atendimento !== 'object'
      ) {
        atendIds.add(item.id_atendimento);
      }
    });
    return { ids, atendIds };
  },
);

export const makeSelectIsPinSelected = (pin) => (state) => {
  const { ids, atendIds } = selectAllSelectedPinIds(state);
  if (pin?.id !== undefined && ids.has(pin.id)) return true;
  if (
    pin?.id_atendimento !== undefined
    && pin?.id_atendimento !== null
    && typeof pin.id_atendimento !== 'object'
    && atendIds.has(pin.id_atendimento)
  ) {
    return true;
  }
  return false;
};

export default routesManagementSlice.reducer;
